import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import logo from "../../../assets/logo.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useSelector } from "react-redux";
import "swiper/css";
import "swiper/css/pagination";

const BestProducts = ({ data }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang?.lang);

	return (
		<div className="products-home-section pb-1">
			<div className="container">
				<div className="d-flex justify-content-between align-items-center">
					<p className="title mb-0">{t("Best Selling Products")}</p>
					<Link to="/best-seller" className="shop-now text-primary">
						{t("Shop Now")}
					</Link>
				</div>
				<div className="products">
					{!!data?.length && (
						<Swiper
							modules={[Pagination]}
							pagination={{ clickable: true }}
							spaceBetween={24}
							slidesPerView={2}
							breakpoints={{
								640: {
									slidesPerView: 2,
									spaceBetween: 20,
								},
								768: {
									slidesPerView: 3,
									spaceBetween: 20,
								},
								1024: {
									slidesPerView: 4,
									spaceBetween: 24,
								},
							}}
							className="mySwiper">
							{data?.map((item, index) => {
								return (
									<SwiperSlide
										key={index}
										onClick={() => navigate(`/products/product/${item?.id}`)}>
										<div className="product">
											<img
												src={
													!!item?.product_images?.length
														? item?.product_images[0]?.url
														: ""
												}
												className="w-100"
												alt="product"
											/>
											<div style={{ padding: "18px", background: "#e1f2f3" }}>
												<p className="product-title text-ellipsis">
													{item[`name_${lang}`]}
												</p>
											</div>
										</div>
									</SwiperSlide>
								);
							})}
						</Swiper>
					)}
					{!data?.length && <h3 className="pb-5">{t(`There's no Product`)}</h3>}
				</div>
			</div>
		</div>
	);
};

export default BestProducts;
